import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Homepage from './components/homepage';
import AnimeHomepage from './components/animeHomepage'
import Category from './components/category'
import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Route } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import QuestionDisplay from './components/questionDisplay'

ReactGA.initialize('UA-135903024-1');

function FateTrivia(props) {
  return (
    <div>
      <Helmet>
        <title>FGO Trivia</title>
      </Helmet>
      <Homepage 
              banner = "Fate Grand Order Trivia"
              categoryPrefix = "fgo"
              introText = "Quiz yourself on noble phantasms, servants, craft essences, and more."
              history={props.history}
          />
    </div>);
}

function RenderCategory(props) {
  return (
  <div>
    <Category history={props.history}/>
  </div>);
}

function FateServantPicTrivia(props) {
  return (
    <div>
      <Helmet>
        <title>FGO Servant Picture Trivia</title>
      </Helmet>
        <Homepage 
                banner = "FGO Servant Trivia"
                categoryPrefix = "fgoServantPic"
                introText = "How well do you know your servant pictures? Try to identify them!"
                link = "/"
                history={props.history}
            />
    </div>
    );
}

function FateBondCeTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Bond CE Trivia</title>
    </Helmet>
    <Homepage 
            banner = "FGO Bond CE Trivia"
            categoryPrefix = "fgoBondCe"
            introText = "How well do you know your bond craft essences? Name the servants by their CEs."
            link = "/"
            history={props.history}
        />
  </div>);
}

function FateSpriteTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Sprite Trivia</title>
    </Helmet>
    <Homepage 
            banner = "FGO Sprite Trivia"
            categoryPrefix = "fgoSprite"
            introText = "Do you know the servant sprites? Try to identify them!"
            link = "/"
            history={props.history}
        />
  </div>);
}


function FateBioTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Servant Bio Trivia</title>
    </Helmet>
    <Homepage 
            title = "FGO Servant Biography Trivia"
            description = "Play the FGO servant biography trivia! Identify the servants based on their biography, things they like and dislike, and things they say."
            banner = "FGO Servant Bio Trivia"
            categoryPrefix = "fgoBio"
            introText = "Do you know what the servants say? Do you know their back stories? Try to identify them!"
            link = "/"
            history={props.history}
        />
  </div>);
}

function FateValentinesTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Valentines CE Trivia</title>
    </Helmet>
    <Homepage 
            title = "FGO Valentines Trivia"
            description = "Play the FGO valentines trivia! Try to identify which servants gave these chocolates to you!"
            banner = "Valentines Chocolate Trivia"
            categoryPrefix = "fgoValentines"
            introText = "Do you know what your servants gave you on Valentines Day? Try to identify them!"
            link = "/"
            history={props.history}
        />
  </div>);
}


function FateShoesTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Shoes Trivia</title>
    </Helmet>
    <Homepage 
            title = "FGO Shoes Trivia"
            description = "Can you identify the FGO servants based on their shoes? Play this trivia quiz and try to identify them!"
            banner = "FGO Shoes Trivia"
            categoryPrefix = "fgoShoes"
            introText = "Do you know what your servants wear? Try to identify the servants!"
            link = "/"
            history={props.history}
        />
  </div>);
}

function FateItemTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>FGO Servant Item Trivia</title>
    </Helmet>
    <Homepage 
            banner = "FGO Item Trivia"
            categoryPrefix = "fgoItem"
            introText = "Do you know the items and weapons that the servants use? Try to name the servant!"
            link = "/"
            history={props.history}
        />
  </div>);
}

function FateNpTrivia(props) {
  return (
  <div>
    <Helmet>
      <title>Noble Phantasm Trivia</title>
    </Helmet>
    <Homepage 
            banner = "Noble Phantasm Trivia"
            categoryPrefix = "fgoNP"
            introText = "Know your Noble Phantasms? Take the quiz!"
            link = "/"
            history={props.history}
        />
  </div>);
}

function AnimeTriviaFilter(props) {
  return <AnimeHomepage history={props.history}></AnimeHomepage>
}

function QuestionDisplayer(props) {
  return (
    <QuestionDisplay/>
    );
}

function AnimeTrivia(props) {
    var malId = props.match.params.malId
    return <Homepage 
        banner = "Anime Trivia"
        categoryPrefix = "anime"
        filter = {{"malId": malId}}
        history={props.history}
    />;
}

function DefaultTrivia(props) {
    var category = props.match.params.category
    var splitted = category.split("_")
    for (var i = 0; i < splitted.length; i++) {
       splitted[i] = splitted[i].charAt(0).toUpperCase() + splitted[i].substring(1);     
    }
    var banner = splitted.join(" ") + " Trivia"; 
    return <Homepage 
        banner = {banner}
        categoryPrefix = {category}
        history={props.history}
    />;
}

ReactDOM.render(
    (
        <Router>
            <Switch>
              <Route exact path='/' component={FateTrivia}/>
              <Route exact path='/category' component={RenderCategory}/>
              <Route exact path='/servantpicture' component={FateServantPicTrivia}/>
              <Route exact path='/craftessence' component={FateBondCeTrivia}/>
              <Route exact path='/bio' component={FateBioTrivia}/>
              <Route exact path='/sprite' component={FateSpriteTrivia}/>
              <Route exact path='/item' component={FateItemTrivia}/>
              <Route exact path='/noblephantasm' component={FateNpTrivia}/>
              <Route exact path='/valentines' component={FateValentinesTrivia}/>
              <Route exact path='/shoes' component={FateShoesTrivia}/>
              <Route exact path='/anime' component={AnimeTriviaFilter}/>
              <Route exact path='/anime/:malId' component={AnimeTrivia}/>
              // <Route exact path='/questionDisplay' component={QuestionDisplayer}/>
              <Route exact path='/:category' component={DefaultTrivia}/>
              <Route path='*' component={FateTrivia}/>
            </Switch>
        </Router>
    )
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js